/* file description */

import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from 'react';
import { Button, ErrorBlock, InfiniteScroll, List, Popover, Space } from 'antd-mobile';
import { RightOutlined } from '@ant-design/icons';
import styles from './index.module.less';
import { ListFilter, ListItem } from './components';
import { useSetState } from 'ahooks';
import { FilterOutline } from 'antd-mobile-icons';
import { reverseArr } from './service';
import _ from 'lodash'

const { Item } = List;

export const MobileTable = forwardRef(
  (
    {
      value,
      rowKey,
      mergeColumns,
      pagination,
      search,
      setTableInfo,
      setParams,
      onRow,
      editableSearchParams,
      mergeOptionColumns,
      toolBarRender,
      notMore,
      onChange,
      tableBaseMode,
      floadSearch,
      rowSelection,
      title,
      mobileRows,
      selectedRows,
    }: any,
    ref,
  ) => {
    const [hasMore, setHasMore] = useState(true);
    const [listValue, setListValue] = useState<{
      [key: string]: Array<Record<any, any>>;
    }>({});

    const formFilterRef = useRef();
    useEffect(() => {
      if (pagination?.current) {
        if (pagination?.current === 1) {
          setListValue({
            1: value || [],
          });
          return;
        }
        setListValue({
          ...listValue,
          [pagination?.current]: value,
        });
      }
      if (value?.length && pagination?.current === 1) {
        setHasMore(true);
      }
      if (pagination?.current > 1 && !value?.length) {
        setHasMore(false);
      }
      // 如果表格受控则全部拉出了数据
      if (!pagination?.current) {
        setListValue({
          1: value || [],
        });
      }
    }, [pagination?.current, value, hasMore, editableSearchParams]);

    const loadMore = async () => {
      if (!value?.length) {
        return;
      }
      if (pagination?.current >= 1) {
        if (listValue[pagination?.current]) {
          setTableInfo({
            pageSize: pagination?.pageSize || 10,
            current: pagination.current + 1,
          });
          await new Promise((r, f) => {
            setTimeout(r, 2000);
          });
        }
      }
    };

    const rowValueChange = (index: number, values: Record<string, any>) => {
      if (index === undefined) return;
      value[index] = { ...value?.[index], ...values };
      onChange([...value]);
    };

    const filterSearch = (v: any) => {
      setListValue({});
      setParams({ ...v });
    };


    useImperativeHandle(ref, () => ({
      validateFields: () => { },
      removeRow: (index: number) => {
        if (!pagination?.current) {
          const newValue = value.filter((x, i) => i !== index);
          onChange(newValue);
          return;
        }
        const newValues = Object.values(listValue).flat() || [];
        const result = reverseArr(newValues.filter((x, i) => i !== index));
        setListValue(result);
      },
      removeRowById: (id: string | string[]) => {
        const ids = _.isArray(id) ? id : [id];
        const newValue = value.filter((x) => !ids.includes(x._id));
        onChange(newValue);
      },
    }));

    const toolBarRenderUI = toolBarRender && toolBarRender();

    return (
      <div className={floadSearch ? styles['fload-table'] : ''}>
        <ListFilter
          setParams={filterSearch}
          editableSearchParams={editableSearchParams}
          mergeColumns={mergeColumns}
          search={search}
          floadSearch={floadSearch}
          ref={formFilterRef}
        />
        {toolBarRenderUI && !floadSearch ? (
          <div className={styles['tool-bar-wrap']}>
            <div style={{ width: 'calc(100% - 90px)' }}>
              {toolBarRenderUI}
            </div>
            {
              !(filterSearch.length === 0 || !search || floadSearch) && (
                <Button
                  fill="none"
                  color="primary"
                  style={{
                    zIndex: 100,
                    background: '#fff',
                  }}
                  onClick={() => {
                    formFilterRef.current!.setShowFilter(true);
                  }}
                >
                  <Space>
                    <FilterOutline />
                    <span>筛选</span>
                  </Space>
                </Button>
              )
            }
          </div>
        ) : null}
        <List>
          {
            (Object.values(listValue).flat() || []).length === 0 && <ErrorBlock status="empty" description="" title="当前没有数据" />
          }
          <ListItem
            selectedRows={selectedRows}
            mobileRows={mobileRows}
            listTitle={title}
            listValue={listValue}
            mergeColumns={mergeColumns}
            mergeOptionColumns={mergeOptionColumns}
            onRow={onRow}
            rowKey={rowKey}
            rowValueChange={rowValueChange}
            tableBaseMode={tableBaseMode}
            rowSelection={rowSelection}
          />
        </List>
        {listValue[1]?.length !== 0 && (
          <InfiniteScroll loadMore={loadMore} hasMore={!notMore && hasMore} />
        )}
      </div>
    );
  },
);
